import { Stack } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";

export default function CalendarLayout() {
  const screenName = "Calendar";

  return (
    <PageLayout
      screenName={screenName}
      titleClassName="text-primary-800"
      headerClassName="mx-dashboard"
      className="py-dashboard"
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
